import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { Button } from "primereact/button";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useOutOfPocketSubStep = () => {
  const location = useLocation();
  const { showModal } = useModal();

  const { axios_helper_no_header } = useAxios();
  const {
    OUT_OF_POCKET_MAX_SCHEDULE,
    ADD_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
    EDIT_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
    DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
  } = ROUTE_PATHS;
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  let {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    description,
    basis,
    steps,
    scheduleName,
  } = currentState;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState({
    opcScheduleName: scheduleName,
    description: description,
    basis: basis,
    steps: steps,
    opdStepNumber: selectedSteps[initialIndex].opdStepNumber,
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();

  const screen_title = "Out Of Pocket Maximum Schedule Substeps";
  const screenNumber = "RCOPS001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "opcScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 40,
    },
    {
      fieldLabel: "OPC Basis*Valid Values",
      name: "basis",
      label: "Basis",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 50,
    },
    {
      fieldLabel: "Steps",
      name: "steps",
      label: "Steps",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "Step Number",
      name: "opdStepNumber",
      label: "Step Number",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "OPC Basis", condition: "*Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (currentIndex < selectedSteps.length - 1) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Out Of Pocket Maximum Schedule Substeps",
      button_handeler: () => {
        subStepValidation();
      },
      button_key: "F6",
    },

    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(EDIT_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      },
    },
  ];

  /*const navigateToAccumsListDetails = (rowData) => {
    navigateToPage(ROUTE_PATHS.ACCUMULATION_CODE_LIST_DISPLAY, [
      ...previousState,
      { ...currentState, currentIndex },
      {
        selectedCodes: [
          { al1AccumulationCodeLst: rowData["opsAccumCodeList"] },
        ],
        previousScreen: location.pathname,
        currentIndex: 0,
      },
    ]);
  };*/

  const viewAccumsCodeList = (rowData) => {
    showModal(
      { default: "RCAL1005" },
      {
        params: {
          lookupType: "local",
          viewType: "local",
          fieldMapping: {
            default: [
              {
                source: "opsAccumCodeList",
                target: "al1AccumulationCodeLst",
                legacy: "al1AccumulationCodeLst",
              },
              {
                source: "al1AccumCodeListDescr",
                target: "al1AccumCodeListDescr",
                legacy: "al1AccumCodeListDescr",
              },
            ],
          },
        },
      },
      null,
      rowData,
      true
    );
  };

  /* Data table column info. */
  const columnDef = [
    { header: "Sub Step", field: "pbdBenDedFlagSequence" },
    { header: "Apply Plan OOP", field: "opsApplyPlanOop" },
    { header: "Basis Override", field: "opsBasis" },
    {
      header: "Accum Code List",
      field: "opsAccumCodeList",
      body: (rowData) => {
        return (
          <Button
            label={rowData.opsAccumCodeList}
            link
            onClick={(e) => {
              viewAccumsCodeList(rowData);
              // navigateToAccumsListDetails(rowData);
            }}
          />
        );
      },
    },
    { header: "OOP Max Individual Amount", field: "opsMbrOopMaxAmount" },
    { header: "OOP Max Family Amount", field: "opsFamOopMaxAmount" },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "schedule";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/opsOopSchedSubstep`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: paramsData.opdStepNumber,
        pbdBenDedFlagSequence: rowData.pbdBenDedFlagSequence,
      };
      axios_helper_no_header("DELETE", "api/opsOopSchedSubstep", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/opsOopSchedSubstep/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const subStepValidation = () => {
    const params = {
      opcScheduleName: paramsData.opcScheduleName,
      opdStepNumber: paramsData.opdStepNumber,
    };

    axios_helper_no_header(
      "GET",
      "api/opsOopSchedSubstep/validateSubStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(ADD_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: selectedRows.length ? selectedRows : [rowData],
            currentIndex: 0,
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    leftButtons,
  };
};

export default useOutOfPocketSubStep;
